import { render, staticRenderFns } from "./orderApprove.vue?vue&type=template&id=574ef70e&scoped=true&"
import script from "./orderApprove.vue?vue&type=script&lang=js&"
export * from "./orderApprove.vue?vue&type=script&lang=js&"
import style0 from "./orderApprove.vue?vue&type=style&index=0&id=574ef70e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ef70e",
  null
  
)

export default component.exports